{
    "apiKey": "AIzaSyBE3JUk9k7hBhTZnNHfc_qshZacWsFXvLY",
    "authDomain": "audirie-connect.firebaseapp.com",
    "projectId": "audirie-connect",
    "storageBucket": "audirie-connect.appspot.com",
    "messagingSenderId": "604728757388",
    "appId": "1:604728757388:web:019e0b9bd4b24d7b7d7fa9",
    "measurementId": "G-K4CLS8PRLG"
}
